import React, { useState, useEffect } from 'react';
import './App.css';
import HomePage from './components/HomePage';
import LudoGame from './components/LudoGame';
import CreateRoom from './components/CreateRoom';
import JoinRoom from './components/JoinRoom';
import Matchmaking from './components/Matchmaking';
import EnvironmentInfo from './components/EnvironmentInfo';
import ErrorBoundary from './components/ErrorBoundary';
import config from './config/environment';

function App() {
  const [currentView, setCurrentView] = useState('home');
  const [gameData, setGameData] = useState(null);

  useEffect(() => {
    // Simple app initialization log
    console.log('Ludo app initialized', {
      environment: config.isDevelopment() ? 'development' : 'production',
      apiUrl: config.getApiUrl()
    });
  }, []);

  const navigate = (view, data = null) => {
    setCurrentView(view);
    setGameData(data);
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case 'home':
        return <HomePage onNavigate={navigate} />;
      case 'create-room':
        return <CreateRoom onNavigate={navigate} />;
      case 'join-room':
        return <JoinRoom onNavigate={navigate} />;
      case 'matchmaking':
        return <Matchmaking onNavigate={navigate} />;
      case 'game':
        return <LudoGame gameData={gameData} onNavigate={navigate} />;
      default:
        return <HomePage onNavigate={navigate} />;
    }
  };
  
  return (
    <ErrorBoundary>
      <div className="App">
        <header className="app-header">
          <h1 onClick={() => navigate('home')}>🎲 Ludo Multiplayer</h1>
        </header>
        {renderCurrentView()}
        <EnvironmentInfo show={config.isDevelopment()} />
      </div>
    </ErrorBoundary>
  );
}

export default App;
